import styled from 'styled-components';
import { media } from 'designsystem';

const BackgroundImage = styled.img`
  position: absolute;
  width: 100%;
  min-width: 400px;
  object-fit: contain;
  
  ${media.desktop`
    position: relative;
    width: initial;
    min-width: initial;
    object-fit: cover;
  `}
`;

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/BackgroundImage.jsx